export default __webpack_public_path__ + "static/media/gallery - spells_02.47839873.jpg";